import { type HomeLocation, type HomeLocationMetadata } from '../types/homeLocationTypes';

export function parseHomeLocation(data: any): HomeLocation {
  const homeLocation: HomeLocation = {
    created_on: data?.created_on || '',
    first_year_change_date: data?.first_year_change_date || '',
    home_metro_code: data?.home_metro_code || '',
    home_zip_code: data?.home_zip_code || '',
    last_changed_on: data?.last_changed_on || '',
    total_changes: data?.total_changes ?? 0,
    year_changes_count: data?.year_changes_count ?? 0,
    max_allowed_changes_per_year: data?.max_allowed_changes_per_year ?? 4,

    parsedProps: {
      isAllowedToUpdate: (data?.year_changes_count ?? 0) < (data?.max_allowed_changes_per_year ?? 4),
      remainingChanges: (data?.max_allowed_changes_per_year ?? 4) - (data?.year_changes_count ?? 0),
    },

    metadata: parseHomeLocationMetadata(data?.metadata),
  };

  return homeLocation;
}

export function parseHomeLocationMetadata(data: any): HomeLocationMetadata | undefined {
  if (!data) {
    return;
  }

  if ('x-ent-home-location' in data && data['x-ent-home-location']) {
    return {
      'x-ent-home-location': data['x-ent-home-location'],
    };
  }
}
